export default __webpack_public_path__ + "static/media/awar4.6c8f1e25.jpg";